/* CNOIR homepage — maison layer (2026-10-18). Shipped as an asset because the
   store's speed optimiser blocks late inline scripts inside sections. */
(function () {
  // 1. Fade the header's black gradient as the banner scrolls away.
  var root = document.documentElement;
  var banner = document.querySelector('main .shopify-section:first-child');
  function fade() {
    var h = banner ? banner.offsetHeight : window.innerHeight;
    var v = Math.max(0, 1 - window.scrollY / (h * 0.45));
    root.style.setProperty('--cnoir-scrim', v.toFixed(3));
  }
  window.addEventListener('scroll', fade, { passive: true });
  window.addEventListener('resize', fade);
  fade();

  // 2. Cloth library: clicking a swatch shows it large with its code.
  function initCloths(scope) {
    (scope || document).querySelectorAll('[data-ch-cloths]').forEach(function (wrap) {
      if (wrap.dataset.chReady) return;
      wrap.dataset.chReady = '1';
      var section = wrap.closest('.ch-mtm');
      var big = section.querySelector('[data-ch-cloth-img]');
      var code = section.querySelector('[data-ch-cloth-code]');
      var name = section.querySelector('[data-ch-cloth-name]');
      wrap.querySelectorAll('.ch-cloth').forEach(function (b) {
        b.addEventListener('click', function () {
          wrap.querySelectorAll('.ch-cloth').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          if (big) {
            big.src = b.dataset.img;
            big.removeAttribute('srcset');
            big.alt = 'Fabric swatch: ' + b.dataset.name;
          }
          if (code) code.textContent = b.dataset.code;
          if (name) name.textContent = b.dataset.name;
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCloths(); });
  else initCloths();
  document.addEventListener('shopify:section:load', function (e) { initCloths(e.target); });
  // 3. Film section: plays only while on screen, never autoplays for reduced-motion viewers, with a pause button.
  function initFilms(scope) {
    var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4l13 8-13 8z"/></svg>';
    var PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (scope || document).querySelectorAll('[data-ch-film]').forEach(function (v) {
      if (v.dataset.chReady) return;
      v.dataset.chReady = '1';
      v.chUserPaused = reduce;
      var btn = v.parentNode.querySelector('[data-ch-film-toggle]');
      function sync() { var on = !v.paused; btn.innerHTML = on ? PAUSE : PLAY; btn.setAttribute('aria-label', on ? 'Pause video' : 'Play video'); }
      v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
      btn.addEventListener('click', function () {
        if (v.paused) { v.chUserPaused = false; v.play().catch(function () {}); } else { v.chUserPaused = true; v.pause(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting && !v.chUserPaused) v.play().catch(function () {}); else v.pause(); });
        }, { threshold: 0.35 }).observe(v);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initFilms(); });
  else initFilms();
  document.addEventListener('shopify:section:load', function (e) { initFilms(e.target); });
})();
